import React from "react";
import {styled} from "@mui/material/styles";
export default function DividingLine({children, ...props}) {
    return (
        <Container/>
    );
}

const Container = styled('div')({
    background: '#0000001A',
    width: '200px',
    maxWidth: '100%',
    height: '1px',
    margin: '25px 0 28px',
});
